import * as React from 'react'
import PropTypes from 'prop-types'

const CreditCardIcon = ({ width = 48, height = 32, color = '#101820' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 6.53V3.653a3.64 3.64 0 011.087-2.579A3.734 3.734 0 013.699 0h40.6c.98.003 1.92.389 2.613 1.073a3.64 3.64 0 011.086 2.58V6.53H0zm47.998 5.19v16.628a3.639 3.639 0 01-1.086 2.58A3.733 3.733 0 0144.3 32H3.699a3.733 3.733 0 01-2.613-1.073A3.639 3.639 0 010 28.347V11.72h47.998zM12.722 26.962H5.431v1.296h7.291v-1.296zM14.19 16.26a.775.775 0 00-.231-.55.795.795 0 00-.556-.229h-7.27c-.21 0-.41.083-.558.229a.776.776 0 00-.231.55v6.141c0 .207.084.404.232.55a.796.796 0 00.557.228h7.27a.796.796 0 00.555-.229.776.776 0 00.232-.549v-6.14zm7.336 10.703h-7.291v1.296h7.291v-1.296zm8.803 0h-7.292v1.296h7.292v-1.296z"
        fill={color}
      />
    </svg>
  )
}

CreditCardIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(CreditCardIcon)
